<script>

import { useToast } from "vue-toastification";
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

import UserCircle from '@/ui/UserCircle'

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'
import CheckboxTableSelectOne from '@/ui/CheckboxTableSelectOne'
import CheckboxTableSelectAll from '@/ui/CheckboxTableSelectAll'
import ButtonTableResetAllSelected from '@/ui/ButtonTableResetAllSelected'

//store
import {useSelectedItemStore} from "@/stores/selectedItem";

import WeatherEdit from '@/components/CustomWeather/WeatherBasic/WeatherEdit.vue'
import WeatherDelete from '@/components/CustomWeather/WeatherBasic/WeatherDelete.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//data
import { getWeathers, unlockWeather } from '@/services/weather/serviceWeather';

export default {
	setup() {
		let selectedItemStore = useSelectedItemStore();
		const allSelectedItems = selectedItemStore.getAllSelectedItems;

		const toast = useToast();
		return { toast, allSelectedItems, selectedItemStore }
	},
	name: 'WeatherBasic',
	mixins: [ MixinGeneralFunct ],
	components: {
		WeatherEdit,WeatherDelete
		,UserCircle
		,MyPagination,MyCountRecords
		,LoadingScreen
		,Alert
		,CheckboxTableSelectOne
		,CheckboxTableSelectAll
		,ButtonTableResetAllSelected
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			
            metaData:[],
            
            isLoading:true,

            totalCount:0,
            dataList:[],
            selectedFilterText:'',
            
            selectedWeatherId:'',

            countPages:0,
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
					
			showFilter:false,
			filterExtended:false,
			
			showedHelpbox:false,

			modalDelete:{},
			modalDeleteId:'',

			modalEdit:{},
			modalEditId:'',


		}
	},
	
	mounted:function(){
		this.modalDeleteId = `modal${this.getRandomInt(999999999)}`;
		this.modalEditId = `modal${this.getRandomInt(999999999)}`;
	},
	
	methods: {
				
		onLoadPage:function(){


			this.isLoading=true

			getWeathers({filterText: this.selectedFilterText, orderCol: this.selectedCol, orderSort: this.selectedSort, page: this.selectedPage, records: this.selectedRecords}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.dataList = response.results;
					this.metaData = response.metaData;
					this.totalCount = response.totalCount;
				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});

		},
		
		//odomknutie zaznamu
		onUnLock:function(weatherId){
			this.cSession();
			this.isLoading=true
			unlockWeather(weatherId).then(response => {
				if(!response.statusText){
					this.isLoading=false
					if(response.resCode==1){
						this.toast.success(this.$t('msgCore.dataWasUnlocked'));
						this.onLoadPage();
					}else if(response.resCode==0){
						this.toast.warning(this.$t('msgCore.dataCantBeUnlocked'));
					}else if(response.resCode==2){
						this.toast.error(this.$t('msgCore.dataWasNotUnlocked'));
					}else if(response.resCode==3){
						this.toast.error(this.$t('msgCore.accessDenied'));
					}
					
				}else{
					this.isLoading=false
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
		},

		
		//(od)oznacenie vsetkych poloziek
		handleSelectedItems:function(e){
			this.dataList=e;
		},

		//radenie zoznamu - orders by
		orderByCol:function(col){
			
			if(col === this.selectedCol) {
				this.selectedSort = this.selectedSort==='asc'?'desc':'asc';
			}
			this.selectedCol = col;
			
			this.onLoadPage();
		},
		
		
		//active menu
		isActive: function (col) {
			return this.selectedCol === col;
		},
		isAsc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'asc'){
				return true;
			}
		},
		isDesc: function (col) {
			if(this.selectedCol === col && this.selectedSort === 'desc'){
				return true;
			}
		},
		
		//zobrazi filtre
		showFilters: function(){
			if(!this.showFilter) {
				this.showFilter = true;
			}else{
				this.showFilter = false;
			}
		},
		
		//vycisti text filter
		resetTextFilter: function(){
			this.selectedFilterText = '';
			this.onLoadPage();
		},
		
		// zobrazi napovedu
		showHelpbox: function(){
			if(!this.showedHelpbox) {
				this.showedHelpbox = true;
			}else{
				this.showedHelpbox = false;
			}
		},
		// systemove funkcie k zoznamu KONIEC
		
		
		//modal box  editacia
		loadModalFormWeatherEdit:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedWeatherId=String(recordID);
			this.modalEdit = new bootstrap.Modal(document.getElementById(this.modalEditId), {backdrop:'static'})
			this.modalEdit.show();
		},
		
		//modal box  delete
		loadModalFormWeatherDelete:function(recordID){
			this.cSession();
			//console.log(recordID)
			this.selectedWeatherId=String(recordID);
			this.modalDelete = new bootstrap.Modal(document.getElementById(this.modalDeleteId), {backdrop:'static'})
			this.modalDelete.show();
		},

		
		
		

		
		//zmena zaznamu
		onChangeItem() {
			this.onLoadPage();
			this.selectedWeatherId='';
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.selectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.selectedPage=1;
			this.selectedRecords=selectedCount
			this.onLoadPage();
		},

	
	
		
	},	
	
			
	watch: {
		'auth.campaignsList': function () {
			this.onLoadPage();
		},
		dataList() {
			//oznacenie vybranych poloziek
			for(let i = 0; i < this.dataList.length; i++){
				if(this.allSelectedItems.indexOf(this.dataList[i].id)>=0){
					this.dataList[i].selectedId=true;
				}
			}
		},
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
	<div id="version" class="version"><p>{{metaData.version}}</p></div>

		<div v-if="metaData.modulAccess" > 
					
            <div class="row">
                <div class="col-12">
                                    
					<div class="row">
						<div class="col-6">
							<h5>{{ $t('msgCustomWeather.Weather') }}</h5>	 
						</div> 
						
						<div class="col-6 right">
							<button type="button" :disabled="!auth.campaignsNew" v-on:click="loadModalFormWeatherEdit(null)" class="btn btn-primary btn-sm"><i class="smire-icon fas fa-plus"></i> {{ $t('msgCore.btnAdd') }}</button>
						</div> 
					</div>

					<!-- filters basic -->
					<div class="row">
						<div class="input-group col-md-4 col-12">
							<button type="button" :title="$t('msgCore.btnFilter')" class="btn btn-info btn-sm my-btn" v-on:click="showFilters()">
								<span v-if="filterExtended">
									<i v-if="!showFilter" class="smire-icon fas fa-search-plus"></i> 
									<i v-else class="smire-icon fas fa-search-minus"></i>
								</span>
								<span v-else>
									<i class="smire-icon fas fa-search"></i> 
								</span>
								{{ $t('msgCore.btnFilter') }}
							</button>
							<input type="text" class="form-control form-control-sm" v-model='selectedFilterText' :placeholder="$t('msgCore.searchTitle')" v-on:change="onLoadPage()">
							<button type="button" :title="$t('msgCore.btnStorno')" class="btn btn-outline-info btn-sm my-btn" v-on:click="resetTextFilter()">
								<i class="smire-icon fas fa-times"></i>
							</button>
						</div>
					</div>
					

					<!-- filters extended -->
					<div v-show="showFilter && filterExtended" class="row">
						<div class="input-group form-group-filter col-4">
					
														
						</div>					
					</div>
                        
                    
                </div>
            </div>	

            
            <!-- zakladny zoznam -->
            <div v-if="totalCount>0">
            
                    <div class="row">
                        <div class="col-12">
        
                            <div class="table-responsive">
                                <table class="table table-hover table-sm">
                                
                                    <thead>
                                        <tr>
											<th class="orderBy" v-on:click="orderByCol('a.id')" :class="{ active: isActive('a.id'), asc: isAsc('a.id'), desc: isDesc('a.id')}">ID</th>
                                        
                                            <th width="10" class="align-middle">
												<CheckboxTableSelectAll :dataList="dataList" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems" @changeSelected="handleSelectedItems"/>
											</th>
                                        
                                            <th>
                                                {{$t('msgCore.Action')}}
                                            </th>
                                            
											<th>{{$t('msgCore.State')}}</th>
                                                                                        
                                            <th>{{$t('msgCustomWeather.FromDate')}}</th>

											<th>R</th>
											<th>O</th>
											<th>V</th>

											<th>Min</th>
											<th>Max</th>
                                            
                                            <th>{{$t('msgCore.Created')}}</th>
                                            
                                            <th>{{$t('msgCore.Modified')}}</th>
                                            
                                            <th>{{$t('msgCore.AccessLevel')}}</th>									
                                        </tr>
                                    </thead>
                                    
                                    
                                    <tr v-for="(basicObj) in dataList" :key="basicObj">
                                    
                                        <td>{{ basicObj.id }}</td>
                                        
										<td class="align-middle">
											<CheckboxTableSelectOne :dataList="dataList" :id="basicObj.id" :selectedId="basicObj.selectedId" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems" @changeSelected="handleSelectedItems" />
                                        </td>
                                    
                                        <td>
                                            <div class="input-group">	
                                                
                                                <button v-if="basicObj.isCheckedOut" type="button" :disabled="!auth.campaignsUnlock" v-on:click="onUnLock(basicObj.id)" v-bind:title="basicObj.checkedOutName+', '+basicObj.isCheckedOutDate" class="btn btn-sm"><i class="smire-icon fas fa-lock"></i></button>
                                                
                                                <div class="btn-group">				
                                                    <button type="button" :disabled="!auth.weatherEdit" v-on:click="loadModalFormWeatherEdit(basicObj.id)" :title="$t('msgCore.btnEdit')" class="btn btn-secondary btn-sm"><i class="smire-icon fas fa-edit"></i></button>
                                                    
                                                    <button type="button" :disabled="!auth.weatherDelete" v-on:click="loadModalFormWeatherDelete(basicObj.id)" :title="$t('msgCore.btnDelete')" class="btn btn-danger btn-sm"><i class="smire-icon fas fa-trash-alt"></i></button>

                                                </div>	
                                                
                                                
                                            </div>	
                                        </td>
                                        
                                        <td  :title="$t('msgCore.' + basicObj.state_name)">
											<i class="fas fa-circle" :class="{'text-success':basicObj.state==1,'text-danger':basicObj.state==2}" ></i>
										</td>	

                                        <td>{{ basicObj.date_current }}</td>

										<td>{{ basicObj.morning_temp_value }}</td>
										<td>{{ basicObj.atnoon_temp_value }}</td>
										<td>{{ basicObj.evening_temp_value }}</td>

										<td>{{ basicObj.min_temp_value }}</td>
										<td>{{ basicObj.max_temp_value }}</td>
                                        
                                        <td>
											<UserCircle :firstName="basicObj.creatorFirstName" :surName="basicObj.creatorSurName" :color="basicObj.creatorColor" :date="basicObj.created"/>
                                        </td>

										<td>
											<UserCircle :firstName="basicObj.editorFirstName" :surName="basicObj.editorSurName" :color="basicObj.editorColor" :date="basicObj.modified"/>
                                        </td>
                                        
                                        <td>{{ basicObj.access_name }}</td>
                                        
                                        
                                    </tr>
                                        

                                
                                </table>	
                            </div>		
                        
                        </div>
                    </div>

					<div class="row row-pagination">
						<div class="col-6 col-md-3 col-lg-2">
							<MyCountRecords :selectedRecords="selectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
						</div>
						
						<div class="col-6 col-md-3 col-lg-2 box-flex">
							<ButtonTableResetAllSelected :dataList="dataList" :totalCount="totalCount" :selectedItemStore="selectedItemStore" :allSelectedItems="allSelectedItems"  @changeSelected="handleSelectedItems" />
							
						</div>
						
						<div class="col-12 col-md-6 col-lg-8">	
							<MyPagination :selectedRecords="selectedRecords" :totalCount="totalCount" :selectedPage="selectedPage" @onSelectPage="onChangePage"></MyPagination>
						</div>
					</div>
                    
                
            </div>	
            
            <div v-else class="row">
                <div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
				</div>						
            </div>
            
        </div>	
        
        <div v-else class="container-fluid">
            <div class="row">
                <div class="col-12 mt-3">
					<Alert type="warning" :label="$t('msgCore.accessDenied')" />
                </div>
            </div>
        </div>
	
		<WeatherEdit :auth="auth" :secData="secData" :weatherId="selectedWeatherId" @changeRecord="onChangeItem" :modalObject="modalEdit" :modalId="modalEditId"></WeatherEdit>
		<WeatherDelete :auth="auth" :secData="secData" :weatherId="selectedWeatherId" @changeRecord="onChangeItem" :modalObject="modalDelete" :modalId="modalDeleteId"></WeatherDelete>
		
	</div>	
		
</template>


